import React, { useEffect, useState } from "react";
import './loapoiframe.css';
import { showToast } from './toastUtils';
import FullscreenLoader from './FullscreenLoader';
import { queuedApiFetch } from './api';

// Default Fallback Data for LOA/PO Table if network/API is completely empty
const DEFAULT_DUMMY_LOA_PO_DATA = [
  {
    P_grp_desc: "Main Construction",
    P_grp_item_desc: "Main Contract Sum",
    vendor_name: "Woh Hup (Private) Limited",
    contract_no: "NUS-CON-2024-001",
    rateby_lumpsum: "0.00",
    apv_tender_ref_no: "NUS/TDR/2024/001",
    po_no: "PO-2024-8891",
    interim_po_amount_wo_gst: 15450000.00,
    final_po_amount_wo_gst: 15450000.00,
    totalValue: 15450000.00,
    finalValue: 0
  },
  {
    P_grp_desc: "Consultancy Services",
    P_grp_item_desc: "Consultant Fees (Arch)",
    vendor_name: "DP Architects Pte Ltd",
    contract_no: "NUS-ARC-2024-002",
    rateby_lumpsum: "4.50",
    apv_tender_ref_no: "NUS/TDR/2024/002",
    po_no: "PO-2024-8892",
    interim_po_amount_wo_gst: 695250.00,
    final_po_amount_wo_gst: 695250.00,
    totalValue: 695250.00,
    finalValue: 0
  },
  {
    P_grp_desc: "Consultancy Services",
    P_grp_item_desc: "Consultant Fees (C&S)",
    vendor_name: "KTP Consultants Pte Ltd",
    contract_no: "NUS-CNS-2024-003",
    rateby_lumpsum: "3.20",
    apv_tender_ref_no: "NUS/TDR/2024/003",
    po_no: "PO-2024-8893",
    interim_po_amount_wo_gst: 494400.00,
    final_po_amount_wo_gst: 494400.00,
    totalValue: 494400.00,
    finalValue: 0
  },
  {
    P_grp_desc: "Consultancy Services",
    P_grp_item_desc: "Consultant Fees (M&E)",
    vendor_name: "Beca Carter Hollings & Ferner",
    contract_no: "NUS-MNE-2024-004",
    rateby_lumpsum: "3.50",
    apv_tender_ref_no: "NUS/TDR/2024/004",
    po_no: "PO-2024-8894",
    interim_po_amount_wo_gst: 540750.00,
    final_po_amount_wo_gst: 540750.00,
    totalValue: 540750.00,
    finalValue: 0
  },
  {
    P_grp_desc: "Consultancy Services",
    P_grp_item_desc: "QS Fees",
    vendor_name: "Rider Levett Bucknall",
    contract_no: "NUS-QS-2024-005",
    rateby_lumpsum: "1.20",
    apv_tender_ref_no: "NUS/TDR/2024/005",
    po_no: "PO-2024-8895",
    interim_po_amount_wo_gst: 185400.00,
    final_po_amount_wo_gst: 185400.00,
    totalValue: 185400.00,
    finalValue: 0
  },
  {
    P_grp_desc: "Contingency",
    P_grp_item_desc: "Project Contingency",
    vendor_name: "NUS In-House",
    contract_no: "NUS-CTG-2024-006",
    rateby_lumpsum: "0.00",
    apv_tender_ref_no: "NUS/TDR/2024/006",
    po_no: "PO-2024-8896",
    interim_po_amount_wo_gst: 800000.00,
    final_po_amount_wo_gst: 800000.00,
    totalValue: 800000.00,
    finalValue: 0
  }
];

function Loapoiframe() {
  const [dataLoading, setDataLoading] = useState(false);
  const [LOAdataLoading, setLOADataLoading] = useState(false);
  const [itemList, setItemList] = useState([]);
  const getProjectDetails = localStorage.getItem('projectDetails');
  const selectedProjectDetail = getProjectDetails ? JSON.parse(getProjectDetails) : {};
  const projectid = selectedProjectDetail?.projectNumber || selectedProjectDetail?.projectId || selectedProjectDetail?.id || "PRJ-001";

  const getUserDetails = localStorage.getItem('userDetails');
  const userDetails = getUserDetails ? JSON.parse(getUserDetails) : null;
  const userId = userDetails ? userDetails.id : '';
  const userName = userDetails ? userDetails.name : '';
  const getUserAccess = userDetails ? userDetails.access_level : 'account_admin';

  const [userCompany, setUserCompany] = useState(() => {
    const stored = localStorage.getItem('userCompany');
    if (stored) {
      try { return JSON.parse(stored); } catch { return stored; }
    }
    return userDetails?.company_name || 'NUS';
  });
  const getUserCompanyDetails = userCompany;
  const getUserEmail = localStorage.getItem('userEmail') || userDetails?.email || '';
  const [userPermission, setUserPermission] = useState(getUserAccess || 'account_admin');
  const [userRoleManual, setUserRolesManual] = useState('Admin');
  const [loading, setLoading] = useState(false);
  const [editValues, setEditValues] = useState({});
  const [apvContracts, setApvContracts] = useState([]);
  const [proj_access_level, setProjAccessLevel] = useState(false);

  // Normalize discipline text into standard key: ARCH, CS, ME, QS, CONTRACTOR
  const normalizeDisciplineKey = (text) => {
    if (!text) return '';
    const lower = text.trim().toLowerCase();
    if (lower.includes('m&e') || lower.includes('m & e') || lower.includes('mech') || lower.includes('electr') || lower.includes('(m&e)') || lower.includes('(me)'))
      return 'ME';
    if (lower.includes('c&s') || lower.includes('c & s') || lower.includes('civil') || lower.includes('struct') || lower.includes('(c&s)') || lower.includes('(cs)'))
      return 'CS';
    if (lower.includes('arch'))
      return 'ARCH';
    if (lower.includes('qs') || lower.includes('quantity') || lower.includes('(qs)'))
      return 'QS';
    if (lower.includes('contractor') || lower.includes('main contract') || lower.includes('builder') || lower.includes('const'))
      return 'CONTRACTOR';
    return lower;
  };

  const getDisciplineDisplayName = (key) => {
    switch (key) {
      case 'ARCH': return 'Architecture';
      case 'CS': return 'Civil & Structural (C&S)';
      case 'ME': return 'M&E';
      case 'QS': return 'Quantity Surveying (QS)';
      case 'CONTRACTOR': return 'Contractor';
      default: return key;
    }
  };

  const fetchApvContracts = async () => {
    try {
      const apvUrl = (process.env.REACT_APP_APV_API_URL || 'http://localhost:5000/api').replace(/\/+$/, '');
      const queryParam = projectid ? `?projectId=${encodeURIComponent(projectid)}` : '';
      const response = await fetch(`${apvUrl}/contracts${queryParam}`);
      if (response.ok) {
        const resData = await response.json();
        setApvContracts(resData?.data || []);
      }
    } catch (err) {
      console.warn('Could not fetch APV contracts for mapping:', err);
    }
  };

  const fetchUserCompany = async () => {
    if (!getUserEmail) return;
    try {
      const data = await queuedApiFetch(`/user/getuserprofile?emailid=${getUserEmail}`);
      if (data?.apistatus?.Status_Code === 200 && data?.apistatus?.Status_Description?.toLowerCase() === 'success') {
        setUserCompany(data.data.company_name);
        setUserPermission(data.data.access_level);
      }
    } catch (error) {
      console.error('Error fetching user company:', error);
    }
  };

  const fetchUserRole = async () => {
    if (!userId || !projectid) return;
    try {
      const data = await queuedApiFetch(`/funding/get_project_role?userid=${userId}&projectid=${projectid}`);
      if (data?.apistatus?.Status_Code === 200 && data?.apistatus?.Status_Description?.toLowerCase() === 'success') {
        setUserRolesManual(data.data);
      }
    } catch (error) {
      console.error('Error fetching user role:', error);
    }
  };

  const fetchData = async () => {
    try {
      await Promise.all([fetchUserCompany(), fetchUserRole(), fetchApvContracts()]);
    } catch (error) {
      console.error("Error fetching permission data:", error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchEditWBSData();
  }, [projectid]);

  const fetchEditWBSData = async () => {
    setDataLoading(true);
    try {
      const data = await queuedApiFetch(`/funding/getwbsgroup?projectid=${projectid}`);
      if (data?.apistatus?.Status_Code === 200 && data?.apistatus?.Status_Description?.toLowerCase() === 'success') {
        // Include ALL disciplines (do not exclude M&E)
        const filteredData = (data.data || [])
          .map(({ ID, Project_id, P_grp_desc, P_grp_item_desc, P_grp_wbs_value }) => ({
            ID,
            Project_id,
            P_grp_desc,
            P_grp_item_desc,
            P_grp_wbs_value: Number(P_grp_wbs_value) || 0
          }));

        const groupedData = filteredData.reduce((acc, item) => {
          const groupKey = `${item.P_grp_desc}||${item.P_grp_item_desc}`;

          if (!acc[groupKey]) {
            acc[groupKey] = { totalValue: 0, items: [] };
          }

          acc[groupKey].totalValue += item.P_grp_wbs_value || 0;
          acc[groupKey].items.push(item);

          return acc;
        }, {});

        const finalData = Object.keys(groupedData).map(key => {
          const [P_grp_desc, P_grp_item_desc] = key.split('||');

          return {
            P_grp_desc,
            P_grp_item_desc,
            totalValue: groupedData[key].totalValue,
            items: groupedData[key].items,
            finalValue: 0
          };
        });

        const uniqueData = finalData.filter(
          (item, index, self) =>
            index === self.findIndex((t) =>
              t.P_grp_desc === item.P_grp_desc && t.P_grp_item_desc === item.P_grp_item_desc
            )
        );

        const getloaData = await getLOAData();

        const clean = (s) => (s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
        const matchedData = uniqueData.map(uData => {
          if (!uData.P_grp_item_desc) return uData;
          const itemWords = uData.P_grp_item_desc.trim().toLowerCase();
          const cleanItem = clean(uData.P_grp_item_desc);

          const match = (getloaData || []).find(gData => {
            if (!gData?.description) return false;
            const gWords = gData.description.trim().toLowerCase();
            const cleanG = clean(gData.description);
            return (
              gWords === itemWords ||
              cleanG === cleanItem ||
              gWords.includes(itemWords) ||
              itemWords.includes(gWords)
            );
          });

          const baseBudget = match?.original_budget ? parseFloat(match.original_budget) : 0;
          const effectiveTotal = uData.totalValue > 0 ? uData.totalValue : baseBudget;
          const initialRate = match?.rateby_lumpsum ? parseFloat(match.rateby_lumpsum) : 0;
          const initialFinal = initialRate > 0 ? (initialRate / 100) * effectiveTotal : effectiveTotal;

          return match 
            ? { ...uData, ...match, totalValue: effectiveTotal, finalValue: initialFinal } 
            : { ...uData, totalValue: effectiveTotal, finalValue: initialFinal };
        });

        // Also add any items from getloaData that were not in uniqueData
        const unmatchedLoa = (getloaData || []).filter(g => {
          if (!g?.description) return false;
          const cleanG = clean(g.description);
          return !uniqueData.some(u => clean(u.P_grp_item_desc) === cleanG || (u.P_grp_item_desc || '').toLowerCase().includes((g.description || '').toLowerCase()));
        }).map(g => {
          const baseBudget = g.original_budget ? parseFloat(g.original_budget) : 0;
          return {
            P_grp_desc: g.description?.toLowerCase().includes('contract') ? 'Main Construction' : 'Consultancy Services',
            P_grp_item_desc: g.description,
            totalValue: baseBudget,
            items: [],
            finalValue: baseBudget,
            ...g
          };
        });

        const combined = [...matchedData, ...unmatchedLoa];
        if (combined.length > 0) {
          setItemList(combined);
        } else {
          setItemList(DEFAULT_DUMMY_LOA_PO_DATA);
        }
      } else {
        const getloaData = await getLOAData();
        if (getloaData && getloaData.length > 0) {
          setItemList(getloaData);
        } else {
          setItemList(DEFAULT_DUMMY_LOA_PO_DATA);
        }
      }
    } catch (error) {
      console.warn("Error fetching data, using dummy fallback if needed:", error);
      setItemList(DEFAULT_DUMMY_LOA_PO_DATA);
    } finally {
      setDataLoading(false);
      setLoading(false);
    }
  };

  const getLOAData = async () => {
    setLOADataLoading(true);
    try {
      const data = await queuedApiFetch(`/funding/get_loa_po_list?projectid=${projectid}`);
      if (data?.apistatus?.Status_Code === 200 && data?.apistatus?.Status_Description?.toLowerCase() === 'success') {
        return data.data || [];
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error fetching LOA data:", error);
      return [];
    } finally {
      setLOADataLoading(false);
    }
  };

  const formatNumber = (value) => {
    const num = parseFloat(value);
    if (isNaN(num)) return '';
    return new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num);
  };

  const handleInputChange = (e, itemDes, fieldName) => {
    let updatedValue;
    if (fieldName === "apv_tender_ref_no") {
      updatedValue = (e.target.value || '').trim();
    } else if (fieldName === "po_no" || fieldName === "vendor_name" || fieldName === "contract_no") {
      updatedValue = e.target.value;
    } else {
      const inputValue = e.target.value.replace(/,/g, '');
      updatedValue = isNaN(parseFloat(inputValue)) ? '' : parseFloat(inputValue);
    }

    const updatedList = itemList.map(item => {
      const desc = item.P_grp_item_desc || item.description;
      if (desc === itemDes) {
        const isFee = desc.trim().toLowerCase().includes("consultant fees") || desc.trim().toLowerCase().includes("qs fees");
        let extra = {};
        if (fieldName === "rateby_lumpsum" && isFee) {
          const rateNum = parseFloat(updatedValue) || 0;
          const baseVal = item.totalValue > 0 ? item.totalValue : (parseFloat(item.original_budget) || 0);
          extra.finalValue = rateNum > 0 ? (rateNum / 100) * baseVal : baseVal;
        }
        return { ...item, [fieldName]: updatedValue, ...extra };
      }
      return item;
    });

    setItemList(updatedList);
  };

  const saveLoaPO = async () => {
    const formattedData = itemList.map(({
      po_no,
      apv_tender_ref_no,
      apvTenderRefNo,
      P_grp_item_desc,
      description,
      vendor_name,
      contract_no,
      rateby_lumpsum,
      interim_po_amount_wo_gst,
      original_budget,
      finalValue,
      totalValue,
      final_po_amount_wo_gst
    }) => {
      const rowDesc = P_grp_item_desc || description || '';
      const isFee = rowDesc.trim().toLowerCase().includes("consultant fees") || rowDesc.trim().toLowerCase().includes("qs fees");

      const feeInterim = finalValue > 0 
        ? parseFloat(finalValue).toFixed(2) 
        : (totalValue > 0 ? parseFloat(totalValue).toFixed(2) : (original_budget ? parseFloat(original_budget).toFixed(2) : "0.00"));

      return {
        project_id: projectid,
        po_no: po_no || '',
        apv_tender_ref_no: (apv_tender_ref_no || apvTenderRefNo || '').trim(),
        description: rowDesc,
        vendor_name: vendor_name || '',
        contract_no: contract_no || '',
        rateby_lumpsum: !isFee
          ? (original_budget ? parseFloat(original_budget).toFixed(2) : "0.00")
          : (rateby_lumpsum ? parseFloat(rateby_lumpsum).toFixed(2) : "0.00"),
        interim_po_amount_wo_gst: isFee
          ? feeInterim
          : parseFloat(interim_po_amount_wo_gst || original_budget || 0).toFixed(2),
        final_po_amount_wo_gst: parseFloat(final_po_amount_wo_gst || 0).toFixed(2),
      };
    });

    const requestOptions = {
      method: 'POST',
      body: JSON.stringify(formattedData),
    };

    try {
      const result = await queuedApiFetch('/funding/insert_loa_po', requestOptions);
      if (result?.apistatus?.Status_Code === 200 && result?.apistatus?.Status_Description?.toLowerCase() === 'success') {
        showToast.success('Data saved successfully');
        localStorage.removeItem('apv_contracts');

        // Trigger automatic APV balance recalculation and update across all projects
        try {
          const apvUrl = (process.env.REACT_APP_APV_API_URL || 'http://localhost:5000/api').replace(/\/+$/, '');
          await fetch(`${apvUrl}/apv/update_total_apv`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ projectId: projectid })
          });
          await fetchApvContracts();
        } catch (syncErr) {
          console.warn('APV balance sync notice:', syncErr);
        }

        fetchEditWBSData();
      } else {
        showToast.error(result?.apistatus?.Status_Description || 'Please try again later');
      }
    } catch (error) {
      console.error('Error saving data:', error);
      showToast.error('Failed to save data. Please check network.');
    }
  };

  // Permission Handling
  const isAuthorized = 
    getUserAccess === 'account_admin' || 
    getUserAccess === 'project_admin' || 
    userPermission === 'account_admin' || 
    userPermission === 'project_admin' || 
    userRoleManual === 'Project Manager (PM)' || 
    userRoleManual === 'Admin' ||
    userRoleManual === '' ||
    !userRoleManual;

  const isDisabled = !isAuthorized;

  return (
    <div className="loapo-bodywrap">
      {loading && <FullscreenLoader />}
      <div className="loapo-container">
        <div className="loapo-header">
          <div className="loapo-header-left">
            <h2 className="loapo-title">LOA / PO Tracking Table</h2>
            {/* <span className="loapo-badge">Project: {projectid || "PRJ-001"}</span> */}
          </div>
          <div className="loapo-header-right">
            <button 
              id="loapo-btn-submit" 
              className="loapo-btn-save btn-save-changes"
              disabled={!isAuthorized}
              style={{ backgroundColor: isAuthorized ? '' : 'grey', cursor: isAuthorized ? 'pointer' : 'not-allowed' }}
              onClick={() => saveLoaPO()}
            >
              Save Changes
            </button>
          </div>
        </div>

        <div className="loapo-table-card">
          <div className="loapo-table-responsive">
            <table className="loapo-table">
              <thead>
                <tr>
                  <th style={{ width: "200px", textAlign: "left" }}>Description</th>
                  <th style={{ width: "180px", textAlign: "left" }}>Vendor Name</th>
                  <th style={{ width: "125px", textAlign: "left" }}>LOA Ref</th>
                  <th style={{ width: "105px", textAlign: "center" }}>Rate (%)/Lump Sum</th>
                  <th style={{ width: "155px", textAlign: "center" }}>APV Tender Ref No.</th>
                  <th style={{ width: "135px", textAlign: "center" }}>PO No.</th>
                  <th style={{ width: "180px", textAlign: "right" }}>
                    <div>Interim PO Amount</div>
                    <div style={{ fontSize: "11px", fontWeight: "600", opacity: 0.85, textTransform: "none", marginTop: "2px" }}>
                      w/o GST ($)
                    </div>
                  </th>
                  <th style={{ width: "210px", textAlign: "right", paddingRight: "16px" }}>
                    <div>Final PO Amount</div>
                    <div style={{ fontSize: "11px", fontWeight: "600", opacity: 0.85, textTransform: "none", marginTop: "2px" }}>
                      w/o GST ($)
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {itemList && itemList.length > 0 ? (
                  itemList
                    .filter(item => {
                      const desc = item.P_grp_item_desc || item.description;
                      return desc && desc !== "null" && desc.trim() !== "" && item.P_grp_desc !== "GST Adjustment";
                    })
                    .map((item, index) => {
                      const itemDesc = item.P_grp_item_desc || item.description || "";
                      const isFee = itemDesc.trim().toLowerCase().includes("consultant fees") || itemDesc.trim().toLowerCase().includes("qs fees");

                      return (
                        <tr key={index} className="loapo-row">
                          <td className="cell-desc font-semibold">{itemDesc}</td>
                          <td className="cell-vendor">{item.vendor_name || "-"}</td>
                          <td className="cell-contract font-mono">{item.contract_no || "-"}</td>
                          <td className="cell-rate text-center">
                            {isFee ? (
                              <input
                                className="loapo-input text-center"
                                style={{ width: "70px", margin: "0 auto" }}
                                defaultValue={item.rateby_lumpsum}
                                type="text"
                                onInput={(e) => {
                                  const value = e.target.value;
                                  if (!/^\d*$/.test(value)) {
                                    e.target.value = value.replace(/\D/g, "");
                                  } else {
                                    handleInputChange(e, itemDesc, "rateby_lumpsum");
                                  }
                                }}
                              />
                            ) : (item.rateby_lumpsum === "" || item.rateby_lumpsum === "0.00" || item.rateby_lumpsum == null) ? (
                              <span className="loapo-badge-lumpsum badge-lumpsum">Lump Sum</span>
                            ) : (
                              item.rateby_lumpsum
                            )}
                          </td>

                          {/* Column: APV Tender Ref No. */}
                          <td className="cell-input text-center">
                            {(() => {
                              const rowDisciplineKey = normalizeDisciplineKey(itemDesc);
                              const matchingContracts = apvContracts.filter(c => normalizeDisciplineKey(c.discipline) === rowDisciplineKey);
                              const currentRef = (item.apv_tender_ref_no ?? item.apvTenderRefNo ?? "").trim();
                              const linkedContract = apvContracts.find(c => (c.referenceNo || "").toLowerCase() === currentRef.toLowerCase());
                              const isMismatch = Boolean(currentRef && linkedContract && normalizeDisciplineKey(linkedContract.discipline) !== rowDisciplineKey);

                              return (
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "2px" }}>
                                  <input
                                    type="text"
                                    list={`apv-options-${index}`}
                                    placeholder={matchingContracts.length > 0 ? (matchingContracts[0]?.referenceNo || "Tender Ref No.") : "Tender Ref No."}
                                    title={currentRef}
                                    value={currentRef}
                                    className="loapo-input"
                                    disabled={isDisabled}
                                    style={{
                                      borderColor: isMismatch ? "#ef4444" : undefined,
                                      backgroundColor: isMismatch ? "#fef2f2" : undefined,
                                    }}
                                    onChange={(e) => handleInputChange(e, itemDesc, "apv_tender_ref_no")}
                                  />
                                  <datalist id={`apv-options-${index}`}>
                                    {matchingContracts.map(c => (
                                      <option key={c.id || c.referenceNo} value={c.referenceNo}>
                                        {c.referenceNo} ({c.discipline} | APV Balance: ${formatNumber(c.totalApv)})
                                      </option>
                                    ))}
                                  </datalist>
                                  {isMismatch && (
                                    <span style={{ fontSize: "10px", color: "#dc2626", fontWeight: "600", maxWidth: "160px", lineHeight: "1.2" }}>
                                      ⚠️ Mismatch: Row is {getDisciplineDisplayName(rowDisciplineKey)}, but {currentRef} is {linkedContract?.discipline}
                                    </span>
                                  )}
                                </div>
                              );
                            })()}
                          </td>

                          {/* Column: PO No. */}
                          <td className="cell-input text-center">
                            <input
                              type="text"
                              placeholder="PO No."
                              title={item.po_no ?? ""}
                              value={item.po_no ?? ""}
                              className="loapo-input"
                              disabled={isDisabled}
                              onChange={(e) => handleInputChange(e, itemDesc, "po_no")}
                            />
                          </td>

                          {/* Interim PO Amount */}
                          <td className="cell-amount text-right">
                            {isFee ? (
                              <span className="loapo-amount-readonly amount-readonly font-mono">
                                ${formatNumber(item.finalValue > 0 ? item.finalValue : (item.totalValue > 0 ? item.totalValue : (item.original_budget || 0)))}
                              </span>
                            ) : (
                              <input
                                type="text"
                                placeholder="0.00"
                                value={
                                  editValues[itemDesc + "_interim"] ??
                                  (item.interim_po_amount_wo_gst == null || item.interim_po_amount_wo_gst === 0
                                    ? ""
                                    : formatNumber(item.interim_po_amount_wo_gst))
                                }
                                onFocus={() => {
                                  const raw = item.interim_po_amount_wo_gst;
                                  setEditValues(prev => ({
                                    ...prev,
                                    [itemDesc + "_interim"]: (raw == null || raw === 0) ? "" : String(raw)
                                  }));
                                }}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  setEditValues(prev => ({ ...prev, [itemDesc + "_interim"]: val }));
                                }}
                                onBlur={(e) => {
                                  const rawVal = e.target.value.replace(/,/g, "").trim();
                                  const num = parseFloat(rawVal);
                                  const finalVal = isNaN(num) ? 0 : num;
                                  handleInputChange(
                                    { target: { value: finalVal } },
                                    itemDesc,
                                    "interim_po_amount_wo_gst"
                                  );
                                  setEditValues(prev => {
                                    const next = { ...prev };
                                    delete next[itemDesc + "_interim"];
                                    return next;
                                  });
                                }}
                                className="loapo-input text-right font-mono"
                                disabled={isDisabled}
                              />
                            )}
                          </td>

                          {/* Final PO Amount */}
                          <td className="cell-amount text-right" style={{ paddingRight: "16px" }}>
                            <input
                              type="text"
                              placeholder="0.00"
                              value={
                                editValues[itemDesc + "_final"] ??
                                (item.final_po_amount_wo_gst == null || item.final_po_amount_wo_gst === 0
                                  ? ""
                                  : formatNumber(item.final_po_amount_wo_gst))
                              }
                              onFocus={() => {
                                const raw = item.final_po_amount_wo_gst;
                                setEditValues(prev => ({
                                  ...prev,
                                  [itemDesc + "_final"]: (raw == null || raw === 0) ? "" : String(raw)
                                }));
                              }}
                              onChange={(e) => {
                                const val = e.target.value;
                                setEditValues(prev => ({ ...prev, [itemDesc + "_final"]: val }));
                              }}
                              onBlur={(e) => {
                                const rawVal = e.target.value.replace(/,/g, "").trim();
                                const num = parseFloat(rawVal);
                                const finalVal = isNaN(num) ? 0 : num;
                                handleInputChange(
                                  { target: { value: finalVal } },
                                  itemDesc,
                                  "final_po_amount_wo_gst"
                                );
                                setEditValues(prev => {
                                  const next = { ...prev };
                                  delete next[itemDesc + "_final"];
                                  return next;
                                });
                              }}
                              className="loapo-input text-right font-mono"
                              disabled={isDisabled}
                            />
                          </td>
                        </tr>
                      );
                    })
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center" style={{ textAlign: "center", padding: "24px", color: "#64748b" }}>
                      {dataLoading || LOAdataLoading ? "Loading LOA/PO records..." : "No records found"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Loapoiframe;
